import styled from 'styled-components';
import Typography from '@seeneco-ui/core/components/typography';
import { textClip } from '@seeneco-ui/core/styles';


const Trigger = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	max-width: 200px;
	min-height: 70px;
	padding: 10px;
	transition: background-color .2s ease-in-out;

	&:hover {
		background-color: #ebebeb;
	}
`;

const TenantName = styled(Typography.Text)`
	max-width: 100%;
	${textClip()}
	margin-right: 14px;

	@media(max-width: 800px) {
		display: none; 
	}
`;

export {
	Trigger,
	TenantName,
};
